function isLocalHostname(hostname: string) {
  return hostname === 'localhost'
    || hostname === '127.0.0.1'
    || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
}

function syncUrlHost(rawUrl: string, fallbackPort?: string) {
  try {
    const url = new URL(rawUrl)
    if (!isLocalHostname(url.hostname)) {
      return rawUrl
    }

    url.hostname = window.location.hostname

    if (fallbackPort && !url.port) {
      url.port = fallbackPort
    }

    return url.toString().replace(/\/$/, '')
  }
  catch {
    return rawUrl
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (!isLocalHostname(window.location.hostname)) {
    return
  }

  config.public.apiBaseUrl = syncUrlHost(config.public.apiBaseUrl, '3001')
  config.public.shortLinkBase = syncUrlHost(config.public.shortLinkBase, '3002')
  config.public.appUrl = window.location.origin
})
